(function ($) {
    $.fn.blockLinks = function () {

        return this.each(function () {

            var block = $(this),
                trigger = $('a.block-link-src', block);

            if (trigger.length < 1) trigger = $('a:eq(0)', block);

            var url = trigger.attr('href'),
                title = trigger.attr('title'),
                domain = $('base').attr('href');

            if (url.charAt(0) === "/") url = url.substr(1);
            if (domain !== undefined && url.indexOf('http') !== 0) url = domain + url;

            if(title === undefined) title = trigger.text();

            block.css('cursor', 'pointer').attr('title', title)
                .hover(function () {
                    trigger.hover();
                });

            trigger.on('click',function(e){ e.preventDefault(); });
            block.on("click", function (e) {

                if(trigger.attr('target') === "_blank") {
                    window.open(url);
                } else {
                    //Check for control click to open in new window.
                    if ( !e.metaKey && e.ctrlKey ) e.metaKey = e.ctrlKey;

                    if(!e.metaKey) {
                        window.location = url;
                    } else {
                        window.open(url);
                    }
                }

            });


        });

    };
})(jQuery);